<template>
    <span class="payroll-ktu-values">
        <template v-if="values.length"><span v-for="(value, index) in values" :key="index" class="payroll-ktu-item"><span v-if="index" class="payroll-ktu-separator" aria-hidden="true"> / </span><span class="payroll-ktu-value" :style="tint(value)" :title="hint(value)" :aria-label="hint(value)">{{ label(value) }}</span></span></template>
        <span v-else>—</span>
    </span>
</template>

<script>
export default {
    name: 'PayrollKtuValues',
    props: {values: {type: Array, default: () => []}},
    methods: {
        label(value) { return Number.isFinite(value) ? String(value).replace('.', ',') : '—'; },
        tint(value) {
            if (!Number.isFinite(value) || value < 0 || value > 5 || value === 4) return {};
            const low = value < 4;
            const color = low ? [190, 61, 61] : [36, 128, 75];
            const intensity = low ? 0.06 + 0.18 * (4 - value) / 4 : 0.06 + 0.12 * (value - 4);
            // Opaque pale tints keep the scale consistent on yellow missing-rate rows.
            return {backgroundColor: `rgb(${color.map(channel => Math.round(255 + (channel - 255) * intensity)).join(', ')})`};
        },
        hint(value) {
            if (!Number.isFinite(value)) return 'КТУ не указан';
            const comparison = value < 0 || value > 5 ? 'вне шкалы 0–5' : value === 4 ? 'норма' : value < 4 ? 'ниже нормы 4' : 'выше нормы 4';
            return `КТУ из табеля: ${this.label(value)} · ${comparison}. Подсветка оценки, не коэффициента начисления.`;
        }
    }
};
</script>

<style scoped>
.payroll-ktu-values { display: inline; font-variant-numeric: tabular-nums; }
.payroll-ktu-item { display: inline-block; white-space: nowrap; }
.payroll-ktu-value { display: inline-block; padding: 2px 5px; border-radius: 4px; color: #28323c; }
.payroll-ktu-separator { color: #6b7280; }
</style>
